module.exports = __webpack_public_path__ + "img/down-white.abf3bc78.svg";